<!--<p-toast [style]="{marginTop: '80px'}"></p-toast>-->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}



<div class="p-4">

  <table>
    <tr>
      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold; ">Id :</td>
      <td>{{logman.logmanId}}</td>
    </tr>
    <tr>

      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold;">Date :</td>
      <td>{{logman.createDate | date:'M/d/yy h:mm:ss a'  }}</td>

    </tr>
    <tr>
      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold;">Severity :</td>
      @if (logman.severity=='REPORT') {
        <td style="color: green;"><b>{{getSeverityName(logman)}}</b></td>
      }
      @if (logman.severity=='INFO') {
        <td style="color: blue;"><b>{{getSeverityName(logman)}}</b></td>
      }
      @if (logman.severity=='DEBUG') {
        <td style="color: grey;"><b>{{getSeverityName(logman)}}</b></td>
      }
      @if (logman.severity=='ERROR') {
        <td style="color: red;"><b>{{getSeverityName(logman)}}</b></td>
      }
      @if (logman.severity=='SUCCESS') {
        <td style="color: green;"><b>{{getSeverityName(logman)}}</b></td>
      }
    </tr>
    <tr>
      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold;">Reference :</td>
      <td>{{logman.referenceId}}</td>
    </tr>
    <tr>

      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold;">Method :</td>
      <td>{{logman.methodName}}</td>

    </tr>
    <tr>
      <td style="min-width: 150px;padding-right:10px; text-align:right; font-weight: bold;">Class :</td>
      <td>{{logman.className}}</td>
    </tr>
    <tr>
      <td colspan="2"><br><br><hr></td>
    </tr>
    <tr>
      <td colspan="2"><pre>{{getMessage(logman.message)}}</pre></td>
    </tr>


  </table>
</div>
